import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass } from '@angular/common';
import { DrawerHeaderState, DrawerTab } from '../drawer';
import { ResponsiveComponent } from '@nx-superprep/shared'
import { resolveProperty, log } from '@nx-superprep/utils'

@Component({
  selector: 'pop-ui-drawer-header',
  standalone: true,
  imports: [NgClass],
  templateUrl: './drawer-header.component.html',
  styleUrls: ['./drawer-header.component.scss'],
})
export class DrawerHeaderComponent extends ResponsiveComponent {

  title: string | undefined
  isControlOnly = false
  activeTab: DrawerTab | undefined
  tabs: DrawerTab[] = []

  private _state?: DrawerHeaderState | undefined
  @Input()
  public get state(): DrawerHeaderState | undefined {
    return this._state
  }
  public set state(value: DrawerHeaderState | undefined) {
    this._state = value
    this.isControlOnly = (this.state?.title ?? '').length === 0 && (this.state?.tabs ?? []).length > 0
    this.tabs = (this.state?.tabs ?? []).filter(t => t.label)
    this.activeTab = (this.state?.tabs ?? []).find(t => t.label.toLowerCase() === this.state?.activeTab?.toLowerCase())
    this.title = this.isControlOnly ? this.activeTab?.title : this.state?.title
  }
  @Output() stateChange = new EventEmitter<DrawerHeaderState>()

  onToggle(tab: DrawerTab) {
    if (this.tabs.length < 2) { return }
    const found = this.tabs.find(t => t.label.toLowerCase() === (tab.label ?? this.activeTab?.label ?? '').toLowerCase())
    if (!this.state || found?.disabled) { return }
    this.state.activeTab = (found ?? this.tabs[0]).label
    this.stateChange.emit(this.state)
  }

  get subtitle() { return resolveProperty(this.activeTab?.subtitle) }

  onAction(event: unknown) {
    log.debug(event)
  }

  isActive(tab: DrawerTab) {
    return !tab.hideLabel && this.state?.activeTab?.toLowerCase() === tab.label.toLowerCase()
  }
  isDisabled(tab: DrawerTab) {
    return tab.disabled
  }

  label(tab: DrawerTab) {
    return tab.hideLabel ? '' : tab.label
  }

  constructor() {
    super()
    this.rootClassName = 'drawer-header-root-class-name'
  }
}
